import {createRouter, createWebHistory} from 'vue-router';
import AdminLayout from '@/layouts/AdminLayout'
import AuthLayout from '@/layouts/AuthLayout'
import Projects from '@/views/projects/Projects'
import Project from '@/views/projects/Project'
import Services from '@/views/services/Services'
import Service from '@/views/services/Service'
import Servers from '@/views/servers/Servers'
import Server from '@/views/servers/Server'
import Logs from '@/views/logs/Logs'
import Monitor from '@/views/monitor/Monitor.vue'
import TgChannels from "@/views/tg_channels/TgChannels.vue";
import TgChannel from "@/views/tg_channels/TgChannel.vue";
import ApiPingList from "@/views/api_ping/ApiPingList.vue";
import EmailMailingList from "@/views/email_mailing/EmailMailingList.vue";
import EmailMailingDetail from "@/views/email_mailing/EmailMailingDetail.vue";

const routes = [
    {
        path: '/auth',
        name: 'auth',
        component: AuthLayout,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/',
        name: 'admin',
        component: AdminLayout,
        meta: {
            requiresAuth: true
        },
        redirect: '/projects',
        children: [
            {
                path: '/projects',
                name: 'projects',
                component: Projects,
                meta: {
                    title: "Проекты"
                },
            },
            {
                path: '/project/:id',
                name: 'project',
                props: true,
                component: Project,
                meta: {
                    title: "Проект детально"
                },
                children: [
                    {
                        path: 'services',
                        name: 'services',
                        props: true,
                        component: Services,
                    },
                ]
            },
            {
                path: 'services',
                name: 'services',
                props: true,
                component: Services,
                meta: {
                    title: "Сервисы"
                },
            },
            {
                path: '/service/:id',
                name: 'service',
                props: true,
                component: Service,
                meta: {
                    title: "Сервис детально"
                },
            },
            {
                path: '/servers',
                name: 'servers',
                props: true,
                component: Servers,
                meta: {
                    title: "Сервера"
                },
            },
            {
                path: '/server/:id',
                name: 'server',
                props: true,
                component: Server,
            },
            {
                path: '/api_ping',
                name: 'api_ping',
                component: ApiPingList,
                meta: {
                    title: "Api ping"
                },
            },
            {
                path: '/email_mailing',
                name: 'email_mailing',
                component: EmailMailingList,
                meta: {
                    title: "Email рассылка"
                },
            },
            {
                path: '/email_mailing/:id',
                name: 'email_mailing_detail',
                props: true,
                component: EmailMailingDetail,
                meta: {
                    title: "Email рассылка детально"
                },
            },
            {
                path: '/monitor',
                name: 'monitor',
                component: Monitor,
                meta: {
                    title: "Мониторинг"
                },
            },
            {
                path: '/logs',
                name: 'logs',
                component: Logs,
                meta: {
                    title: "Журнал"
                },
            },
            {
                path: '/tg_channels',
                name: 'tg_channels',
                props: true,
                component: TgChannels,
                meta: {
                    title: "Telegram чаты"
                },
            },
            {
                path: '/tg_channel/:id',
                name: 'tg_channel',
                props: true,
                component: TgChannel,
                meta: {
                    title: "Список проектов"
                },
            },
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
